import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../../../messages';
import { useInventoryContext } from '../../inventory-context';

import { InventoryAdjustment } from '../../../../../products/product-details/components/tabs/inventory/inventory-adjustment';

import style from './style.module.less';

const name = <FormattedMessage {...messages.actionsColumnHeader} />;

/**
 * Component for displaying inventory actions
 * @param {object} props
 * @param {string} props.productId
 * @param {number} props.stock
 * @param {string} props.inventoryLocationId
 * @returns {JSX.Element}
 */

const Actions = ({ productId, stock, inventoryLocationId }) => {
  const { refreshGridData } = useInventoryContext();

  return (
    <div className={style.adjustments} data-testid='inventory-adjustment-actions'>
      <InventoryAdjustment
        inventoryLocationId={inventoryLocationId}
        onReloadLocations={refreshGridData}
        productId={productId}
        stock={stock}
      />
    </div>
  );
};

export default {
  name,
  getMessageDescriptor: () => messages.actionsColumnHeader,
  render: (data, { isExpanded = false, isFirstRow = true, allData = [] }) => {
    const isFirstofExpandableRows = !isExpanded && isFirstRow && Array.isArray(allData) && allData.length > 1;
    if (data.inventoryLocationId === '-1' || isFirstofExpandableRows) {
      return '';
    }

    if (!data.productActive) {
      return null;
    }

    return (
      <Actions
        inventoryLocationId={data.inventoryLocationId}
        productActive={data.productActive}
        productId={data.productId}
        stock={data.stock}
      />
    );
  },
};
